var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBlogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.625C16.56 5.625 5.625 16.56 5.625 30C5.62499 43.44 16.56 54.375 30 54.375C43.44 54.375 54.375 43.44 54.375 30C54.375 16.56 43.44 5.62501 30 5.625ZM30 9.375C41.4131 9.37501 50.625 18.5869 50.625 30C50.625 41.4131 41.4131 50.625 30 50.625C18.5869 50.625 9.37499 41.4131 9.375 30C9.375 18.5869 18.5869 9.375 30 9.375ZM28.65 17.9888L17.9906 28.65L16.6406 30L17.9906 31.35L28.6537 42.0113L31.35 39.375L23.85 31.875L43.125 31.875L43.125 28.125L23.85 28.125L31.35 20.625L28.65 17.9888Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlogIcon);
export default __webpack_public_path__ + "static/media/arrow-blog-icon.97421d0d705402b3111f9f57bf13059f.svg";
export { ForwardRef as ReactComponent };